const Logo = () =>
  // eslint-disable-next-line no-constant-condition
  false ? (
    <div
      style={{
        position: "fixed",
        top: 20,
        left: 20,
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        background: "white",
        padding: "24px",
        width: "100vw",
      }}
    >
      <img
        style={{ background: "white", marginRight: "10px" }}
        src="https://www.goodskellas.xyz/images/118aEhyb_400x400.svg"
        height={100}
        width={100}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <h2 style={{ margin: 0, fontWeight: 100, fontSize: "2.5rem" }}>GOOD</h2>
        <h2 style={{ margin: 0, fontSize: "2.5rem" }}>SKELLAS</h2>
      </div>
    </div>
  ) : null;

export default Logo;
